import { ref, onMounted } from 'vue';

const aboutSroll = () => {
  const isShowGoDown = ref(true);
  const debounceScroll = (pageDom) => {
    if (pageDom.scrollTop > 600) {
      isShowGoDown.value = false;
    } else {
      isShowGoDown.value = true;
    }
  };
  onMounted(() => {
    const pageDom = document.querySelector('.qris.layout-view');
    pageDom.addEventListener('scroll', () => {
      debounceScroll(pageDom);
    });
  });
  const scrollTo = function (top) {
    const pageDom = document.querySelector('.qris.layout-view');
    pageDom.scrollTo({ left: 0, top, behavior: 'smooth' });
  };
  return {
    isShowGoDown, scrollTo
  }
}

export { aboutSroll }
